import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { SafeUrlPipe } from './safe-url.pipe';
import { StreamPipe } from './stream.pipe';
import { SafePipe } from './safe.pipe';
import { TruncatePipe } from './truncate.pipe';
import { FilenamePipe } from './filename.pipe';
import { YoutubeEmbedPipe } from './youtube-embed.pipe';
import { DocumentsPipe } from './documents.pipe';

@NgModule({
  imports: [
    CommonModule,
    RouterModule
  ],
  declarations: [
    SafeUrlPipe,
    StreamPipe,
    SafePipe,
    TruncatePipe,
    FilenamePipe,
    YoutubeEmbedPipe,
    DocumentsPipe
  ],
  exports: [
    SafeUrlPipe,
    StreamPipe,
    SafePipe,
    TruncatePipe,
    FilenamePipe,
    YoutubeEmbedPipe,
    DocumentsPipe
  ]
})

export class PipeModule { }



// WEBPACK FOOTER //
// ./src/app/@core/pipes/pipe.module.ts